import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import PhoneInput, {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import {
  createDidPorted,
  updateDidPorted,
  verifyMISDN,
} from '../../../../api-services';
import { string_required } from '../../../../validation/validationSchema';
import { parsePhoneNumber } from 'react-phone-number-input';

const initialState = {
  did_number: '',
  renewal_date: '',
  buy_date: '',
  status: '',
  city: '',
  msisdn: '',
};

const AddPorted = ({ setOpenModal, openModal, editData = {}, setEditData }) => {
  const isEdit = editData && Object.keys(editData).length > 0;
  const [initialValues, setInitialValues] = useState(initialState);
  const [isPhoneError, setPhoneError] = useState(false);
  const [isVerifyMSIDN, setIsVerifyMSIDN] = useState(false);
  const queryClient = useQueryClient();

  const validationSchema = Yup.object({
    did_number: string_required,
    buy_date: string_required,
    renewal_date: string_required,
    status: string_required,
    city: string_required,
    msisdn: string_required,
  });
  const { isLoading, mutate } = useMutation(
    isEdit ? 'editPorted' : 'addPorted',
    isEdit ? updateDidPorted : createDidPorted,
    {
      onSuccess: (data) => {
        setOpenModal(false);
        setPhoneError(false);
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('ported-did-listing');
          formik.resetForm();
        });
      },
      onError: (error) => {
        setPhoneError(false);
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    },
  );
  const { isLoading: isLoadingVerifyMISDN, mutate: mutateVerifyMISDN } =
    useMutation('verify-misdn', verifyMISDN, {
      onSuccess: (data) => {
        setIsVerifyMSIDN(true);
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 3000,
        });
      },
      onError: (error) => {
        setIsVerifyMSIDN(false);

        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });
  const handleSubmitForm = (values) => {
    const { did_number, renewal_date, buy_date, status, city, msisdn } = values;
    const phone = parsePhoneNumber(did_number || '');
    const payload = {
      did_number,
      renewal_date,
      buy_date,
      did_status: status,
      uniquecode: isEdit ? editData?.uniquecode : undefined,
      iso: phone?.country || null,
      city,
      msisdn,
    };
    mutate(payload);
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  useEffect(() => {
    if (editData && Object.keys(editData).length > 0) {
      console.log({ editData });
      setIsVerifyMSIDN(true);
      const {
        did_number = '',
        buy_date = '',
        renewal_date = '',
        did_status = '',
        did_city = '',
        customer = {},
      } = editData || {};
      setInitialValues({
        did_number,
        buy_date: new Date(buy_date),
        renewal_date: new Date(renewal_date),
        status: did_status,
        city: did_city,
        msisdn: customer?.msisdn || '',
      });
    }
  }, [editData]);

  const handleClose = () => {
    setOpenModal(false);
    setPhoneError(false);
    setEditData({});
    formik.resetForm();
  };
  const handleVerifyMSIDN = () => {
    if (!formik?.values?.msisdn) {
      swal({
        type: 'danger',
        text: 'Please enter MSISDN',
        icon: 'error',
        timer: 3000,
      });
      return;
    }
    mutateVerifyMISDN({ msisdn: formik?.values?.msisdn });
  };

  useEffect(() => {
    if (formik?.values?.did_number) {
      if (
        !isPossiblePhoneNumber(formik?.values?.did_number) ||
        !isValidPhoneNumber(formik?.values?.did_number)
      ) {
        setPhoneError(true);
      } else {
        setPhoneError(false);
      }
    } else {
      setPhoneError(false);
    }
  }, [formik?.values?.did_number]);

  return (
    <Modal
      size="md"
      centered
      show={openModal}
      onHide={() => handleClose()}
      backdrop="static"
      keyboard={false}
    >
      <form
        onSubmit={formik.handleSubmit}
        className="add-ported-modal
"
      >
        <div className="modal-header ">
          <div className="icon_arrow"></div>
          <h5 className="modal-title heading heading--xs mb-0 ">
            {isEdit ? 'Edit' : 'Add'} Ported
          </h5>
        </div>
        <div className="modal-body">
          <div className="form-group input_control input_control--gap">
            <label htmlFor="did_number" className="form-label">
              DID Number
            </label>
            <div className="w-100 custom-phone-input flag-block">
              {/* <span className="input_flag">
                {presentCountry && presentCountry.isoCode ? (
                  <Flag code={presentCountry.isoCode} />
                ) : null}
              </span> */}
              <PhoneInput
                defaultCountry={'US'}
                international={true}
                addInternationalOption={false}
                withCountryCallingCode={true}
                internationalIcon={() => (
                  <span>
                    <i className="fa fa-phone icon-circle bg-danger"></i>
                  </span>
                )}
                placeholder="Did Number"
                name="did_number"
                onBlur={formik.handleBlur}
                value={formik.values.did_number}
                onChange={(phone, country) => {
                  console.log({ country });
                  formik.setFieldValue('did_number', phone);
                }}
                className="form-control MuiInputBase-input MuiInput-input"
              />
              {(formik.touched.did_number && formik.errors.did_number) ||
              isPhoneError ? (
                <div className="error_required">
                  {formik.errors.did_number || 'Did number not valid'}
                </div>
              ) : null}
            </div>
          </div>

          <div className="row flex align-items-center  msidn-row">
            <div className="w-100 d-flex align-items-end px-3 gutter-3">
              <div className="form-group input_control input_control--gap mb-0">
                <label htmlFor="renewal_date">MSIDN</label>
                <input
                  className="form-control"
                  placeholder="MSIDN"
                  name="msisdn"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.msisdn}
                />
              </div>
              <button
                type="button"
                className="btn btn-dark-blue"
                onClick={handleVerifyMSIDN}
                disabled={isLoadingVerifyMISDN}
              >
                {isLoadingVerifyMISDN ? 'Please wait...' : 'Verify'}
              </button>
            </div>
            {formik.touched.msisdn && formik.errors.msisdn ? (
              <div className="error_required px-3">{formik.errors.msisdn}</div>
            ) : null}
            {/* <div className="col-md-8">
      
            </div> */}
            {/* <div className="col-md-4">
     
            </div> */}
          </div>
          <div className="form-group input_control input_control--gap">
            <label htmlFor="renewal_date">City</label>
            <input
              className="form-control"
              placeholder="City"
              name="city"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.city}
            />
            {formik.touched.city && formik.errors.city ? (
              <div className="error_required">{formik.errors.city}</div>
            ) : null}
          </div>
          <div className="form-group input_control input_control--gap">
            <label htmlFor="buy_date">Buy Date</label>
            <DatePicker
              selected={formik.values.buy_date}
              onChange={(val) => {
                formik.setFieldValue('buy_date', val);
              }}
              className="form-control"
              placeholderText="Buy Date"
            />

            {formik.touched.buy_date && formik.errors.buy_date ? (
              <div className="error_required">{formik.errors.buy_date}</div>
            ) : null}
          </div>
          <div className="form-group input_control input_control--gap">
            <label htmlFor="renewal_date">Renewal Date</label>

            <DatePicker
              id="renewal_date"
              selected={formik.values.renewal_date}
              onChange={(val) => {
                formik.setFieldValue('renewal_date', val);
              }}
              className="form-control"
              placeholderText="Renewal Date"
              minDate={new Date()}
            />
            {formik.touched.renewal_date && formik.errors.renewal_date ? (
              <div className="error_required">{formik.errors.renewal_date}</div>
            ) : null}
          </div>
          <div className="form-group input_control">
            <label htmlFor="renewal_date">Status</label>
            <select
              className="form-control"
              name="status"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.status}
            >
              <option value="">Select status</option>
              <option value="A">Activated</option>
              <option value="D">Deactivated</option>
              <option value="P">Pending</option>
            </select>
            {formik.touched.status && formik.errors.status ? (
              <div className="error_required">{formik.errors.status}</div>
            ) : null}
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleClose()}
          >
            Close
          </button>
          <button
            type="submit"
            disabled={isLoading || isLoadingVerifyMISDN || !isVerifyMSIDN}
            className="btn btn-dark-blue"
          >
            {isLoading ? 'Please Wait...' : `${isEdit ? 'Update' : 'Submit'}`}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddPorted;
